module.exports = require("react-beautiful-dnd");